import React, {Component} from 'react';
import PropTypes from "prop-types";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faImage, faImages, faPlay, faAngleDoubleRight, faArrowLeft, faArrowRight, faSearch, faUser, faTimes, faBars, faArrowDown, faFilter, faPen, faThumbsUp, faThumbsDown, faHeart, faPlus, faBell, faVideo, faTags, faGamepad } from '@fortawesome/free-solid-svg-icons'

library.add(faImages, faImage, faPlay, faAngleDoubleRight, faArrowLeft, faSearch, faUser, faTimes, faBars, faArrowRight, faArrowDown, faFilter, faPen, faThumbsUp, faThumbsDown, faHeart, faPlus, faBell, faVideo, faTags, faGamepad);

class Icon extends Component {
  static propTypes = {
    icon: PropTypes.any.isRequired
  };

  render() {
    const { icon, className } = this.props;

    if (!icon || icon === "") {
      return "";
    }

    if (Array.isArray(icon) && icon[0] === "fab") {
      return <i className={'icon icon-' + icon[1]} />
    }

    return <FontAwesomeIcon className={className} icon={icon} />
  }
}

export default Icon;
